//日期加减参数1（加减日期 默认向后的时间）、参数2（目标时间）
function setTime(num = 1,date = false) {
　　if (!date) {
　　　　date = new Date();//没有传入值时,默认是当前日期
　　　　date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' +         date.getDate();
       date += " 00:00:00";//设置为当天凌晨12点    
　　}
　　date = Date.parse(new Date(date))/1000;//转换为时间戳
　　date += (86400) * num;//修改后的时间戳
　　var newDate = new Date(parseInt(date) * 1000);//转换为时间
　　return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' +       newDate.getDate();
}
export default setTime


// WEBPACK FOOTER //
// ./src/setTime.js